module.exports = __webpack_public_path__ + "img/28-02.8f49c21b.png";